<div class="modal-header">
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>


    <div class="modal-body" >
        <section class="resume services bg-pink" style="height: 500px; overflow-y: scroll;">
            <div class="row">
                <div class="col-md-12 col-lg-12 col-sm-12">
                  <h3 class="text-center" style="margin-top: 0">ORTHOPAEDIC SERVICES FOR MUSKULOSKELETAL CONDITIONS</h3>
                </div>
              </div>
              <div class="row">
                  <div class="col-md-2 col-sm-6" *ngFor="let data of ortho">
                      <div class="service text-center bg-white">
                          <div class="img-block">
                              <img [src]="data.img" alt="" class="service-img img-fluid">
                          </div>
                          <div class="service-feature">
                              <h4 class="feature-text text-center">{{data.title}}</h4>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="row">
                <div class="col-md-12 col-lg-12 col-sm-12">
                  <h3 class="text-center">NEUROLOGICAL</h3>
                </div>
              </div>
              <div class="row">
                  <div class="col-md-2 col-sm-6" *ngFor="let data of neuro">
                      <div class="service text-center bg-white">
                          <div class="img-block">
                              <img [src]="data.img" alt="" class="service-img img-fluid">
                          </div>
                          <div class="service-feature">
                              <h4 class="feature-text text-center">{{data.title}}</h4>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="row">
                <div class="col-md-12 col-lg-12 col-sm-12">
                  <h3 class="text-center">RESPIRATORY</h3>
                </div>
              </div>
              <div class="row">
                  <div class="col-md-2 col-sm-6" *ngFor="let data of respiratory">
                      <div class="service text-center bg-white">
                          <div class="img-block">
                              <img [src]="data.img" alt="" class="service-img img-fluid">
                          </div>
                          <div class="service-feature">
                              <h4 class="feature-text text-center">{{data.title}}</h4>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="row">
                <div class="col-md-12 col-lg-12 col-sm-12">
                  <h3 class="text-center">PILATES</h3>
                </div>
              </div>
              <div class="row">
                  <div class="col-md-2 col-sm-6" *ngFor="let data of pilates">
                      <div class="service text-center bg-white">
                          <div class="img-block">
                              <img [src]="data.img" alt="" class="service-img img-fluid">
                          </div>
                          <div class="service-feature">
                              <h4 class="feature-text text-center">{{data.title}}</h4>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="row">
                <div class="col-md-12 col-lg-12 col-sm-12">
                  <h3 class="text-center">WOMEN'S HEALTH</h3>
                </div>
              </div>
              <div class="row">
                  <div class="col-md-2 col-sm-6" *ngFor="let data of womens">
                      <div class="service text-center bg-white">
                          <div class="img-block">
                              <img [src]="data.img" alt="" class="service-img img-fluid">
                          </div>
                          <div class="service-feature">
                              <h4 class="feature-text text-center">{{data.title}}</h4>
                          </div>
                      </div>
                  </div>
              </div>

              <div class="row">
                <div class="col-md-12 col-lg-12 col-sm-12">
                  <h3 class="text-center">HOME VISITS</h3>
                </div>
              </div>
              <div class="row">
                  <div class="col-md-2 col-sm-6" *ngFor="let data of home">
                      <div class="service text-center bg-white">
                          <div class="img-block">
                              <img [src]="data.img" alt="" class="service-img img-fluid">
                          </div>
                          <div class="service-feature">
                              <h4 class="feature-text text-center">{{data.title}}</h4>
                          </div>
                      </div>
                  </div>
              </div>

        </section>

    </div>
